import { Box } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { appRoutes } from "./config/routes";
import CoreContainer from "./core/layouts/CoreContainer";
import PageNotFound from "./core/layouts/PageNotFound";
import { useSelector } from "react-redux";
import GoogleAnalytics from "./GoogleAnalytics";

function App() {
  const uid = useSelector((state) => state?.auth?.uid);
  console.log("uid in app.js", uid);

  return (
    <Box className="App">
      <BrowserRouter>
        <GoogleAnalytics />
        <Routes>
          {uid
            ? appRoutes
                ?.filter((route) => !route.noAuth)
                ?.map((routeOb, index) => (
                  <Route
                    key={"route-" + index}
                    path={routeOb.url}
                    element={<CoreContainer comp={routeOb.comp} />}
                  />
                ))
            : appRoutes
                ?.filter((route) => route.noAuth)
                ?.map((routeOb, index) => (
                  <Route
                    key={"route-" + index}
                    path={routeOb.url}
                    element={<CoreContainer comp={routeOb.comp} />}
                  />
                ))}
          <Route path="*" element={<CoreContainer comp={<PageNotFound />} />} />
        </Routes>
      </BrowserRouter>
    </Box>
  );
}

export default App;
